import { render, staticRenderFns } from "./NotificationsDropdown.vue?vue&type=template&id=6313aa75&scoped=true&"
import script from "./NotificationsDropdown.vue?vue&type=script&lang=js&"
export * from "./NotificationsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsDropdown.vue?vue&type=style&index=0&id=6313aa75&scoped=true&lang=css&"
import style1 from "./NotificationsDropdown.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6313aa75",
  null
  
)

export default component.exports